import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios';
import {
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CButton, CRow, CCol, CCard, CCardBody
} from '@coreui/react'
import { BsChevronRight } from 'react-icons/bs';
import { FaEdit } from "react-icons/fa";
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';
import Adminprofil from '../../../assets/images/adminprofil.png';
import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './profilpage.css';

const ProfilePage = () => {
    const [UserData, setUserData] = useState([]);
    const [otpSent, setOtpSent] = useState(false);
    const [otpCode, setOtpCode] = useState('');
    const [otpStage, setOtpStage] = useState(false); // pour afficher le champ OTP
    const [passwordForm, setPasswordForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(Adminprofil);
    const [isImageUploading, setIsImageUploading] = useState(false);

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
                
                // Set profile image if available
                if (response.data.picture) {
                    setPreviewImage(response.data.picture);
                }
            } catch (error) {
                toast.error("Failed to fetch user data");
            }
        };
        fetchLoggedUserData();
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setPreviewImage(URL.createObjectURL(file)); // Show preview
        }
    };

    const handleImageUpload = async () => {
        if (!selectedFile) {
            toast.warning("Please select an image first.");
            return;
        }

        setIsImageUploading(true);
        const formData = new FormData();
        formData.append("picture", selectedFile);

        try {
            const response = await api.put(`/api/users/${UserData._id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            toast.success("Profile image updated successfully!");
            
            // Update user data
            const updatedUserData = await api.get('api/usersprofile');
            setUserData(updatedUserData.data);
            
            // Reset file selection
            setSelectedFile(null);
            
        } catch (error) {
            console.error("Error:", error);
            toast.error(error.response?.data?.message || "Failed to upload profile image.");
        } finally {
            setIsImageUploading(false);
        }
    };

    const requestOtp = async (e) => {
        e.preventDefault();
        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            return toast.error("Passwords do not match!");
        }
        if (!passwordForm.currentPassword) {
            return toast.error("Please enter your current password!");
        }

        try {
            await api.post('/api/users/request-password-change', {
                currentPassword: passwordForm.currentPassword,
                newPassword: passwordForm.newPassword
            });
            setOtpStage(true);
            toast.success('A code has been sent to your email');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Error sending OTP');
        }
    };

    const verifyOtp = async (e) => {
        e.preventDefault();
        try {
            await api.post('/api/users/verify-otp-password-change', { otp: otpCode });
            toast.success('Password updated successfully!');
            setOtpStage(false);
            setPasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
        } catch (err) {
            toast.error(err.response?.data?.message || 'Verification error');
        }
    };

    return (
        <>
        <ToastContainer />
      
        <div className="med-profile-dashboard-header">
                        <header className="hosp-header">
                          <CContainer fluid className="d-flex align-items-center">
                            <div className="row w-100">
                              {/* Page title */}
                              <div className="col">
                                <h4 className="hosp-page__title"><b>Profil</b></h4>
                              </div>
                              
                              {/* User profile */}
                              <div className="col d-flex justify-content-end">
                                <div className="hosp-user__profile">
                                  {/* Indicateur de statut en ligne avec classe renommée */}
                                  <div className="hosp-online__indicator"></div>
                                  
                                  <img 
                                    src={UserData?.picture || Adminprofil} 
                                    className="hosp-profile__image" 
                                    alt="User Profile" 
                                    width="50" 
                                    height="50"
                                  />
                                  <div className="hosp-user__details">
                                    <span className="hosp-user__name">{UserData.firstname} {UserData.lastname}</span>
                                    <p className="hosp-user__role">{UserData.role?.name}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </CContainer>
                        </header>
            
            <div className="med-profile-container mt-5">
                <div className="med-profile-row">
                    {/* Section avec photo et informations de profil sur la même ligne */}
                    <div className='med-profil-rassemble'>
                        {/* Carte pour la photo de profil */}
                        <div className="med-profile-col">
                            <div className="med-profile-card">
                                <div className="med-profile-card-body text-center">
                                    <h5 className="med-profile-card-title mb-3">Profile Picture</h5>
                                    <div className="mb-3">
                                        <div className="med-profile-photo-container">
                                            <div className="med-profile-image-wrapper mb-3">
                                                <img 
                                                    src={previewImage} 
                                                    alt="Profile" 
                                                    className="med-profile-image"
                                                />
                                            </div>
                                            <div className="med-profile-photo-edit d-flex align-items-center mb-3">
                                                <label htmlFor="file-input" className="med-profile-btn med-profile-btn-outline-primary">
                                                    <span className="med-profile-icon-edit me-2"></span> Change Photo
                                                </label>
                                                <input 
                                                    type="file" 
                                                    id="file-input" 
                                                    accept="image/*" 
                                                    onChange={handleFileChange}
                                                    style={{ display: 'none' }}
                                                />
                                            </div>
                                            <small className="med-profile-upload-hint text-muted mb-3">
                                                Upload profile photo (jpg, png, jpeg)
                                            </small>
                                            <button 
                                                onClick={handleImageUpload} 
                                                disabled={isImageUploading || !selectedFile}
                                                className="med-profile-btn med-profile-btn-primary med-profile-upload-btn w-100"
                                            >
                                                {isImageUploading ? (
                                                    <>
                                                        <span className="med-profile-spinner me-2" role="status" aria-hidden="true"></span>
                                                        Uploading...
                                                    </>
                                                ) : 'Update Profile Picture'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Carte pour les informations de profil */}
                        <div className="med-profile-col">
                            <div className="med-profile-card">
                                <div className="med-profile-card-body">
                                    <h5 className="med-profile-card-title">Profile Information</h5>
                                    <div className="med-profile-info-container">
                                        <p><strong>Name:</strong> <span>{UserData.lastname} {UserData.firstname}</span></p>
                                        <p><strong>Email:</strong> <span>{UserData.email}</span></p>
                                        <p><strong>Role:</strong> <span>{UserData.role?.name}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Section pour le changement de mot de passe (reste en pleine largeur) */}
                    <div className="med-profile-col">
                        <div className="med-profile-card">
                            <div className="med-profile-card-body">
                                <h5 className="med-profile-card-title mb-4">Change Password</h5>
                                {!otpStage ? (
                                    <form onSubmit={requestOtp} className="med-profile-password-form">
                                        <div className="mb-3">
                                            <label htmlFor="currentPassword" className="med-profile-label">Current Password</label>
                                            <input 
                                                type="password" 
                                                id="currentPassword"
                                                placeholder="Enter current password" 
                                                value={passwordForm.currentPassword}
                                                onChange={e => setPasswordForm({ ...passwordForm, currentPassword: e.target.value })}
                                                className="med-profile-control" 
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="newPassword" className="med-profile-label">New Password</label>
                                            <input 
                                                type="password" 
                                                id="newPassword"
                                                placeholder="Enter new password" 
                                                value={passwordForm.newPassword}
                                                onChange={e => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
                                                className="med-profile-control" 
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="confirmPassword" className="med-profile-label">Confirm Password</label>
                                            <input 
                                                type="password" 
                                                id="confirmPassword"
                                                placeholder="Confirm new password" 
                                                value={passwordForm.confirmPassword}
                                                onChange={e => setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })}
                                                className="med-profile-control" 
                                            />
                                        </div>

                                        <button type="submit" className="med-profile-btn med-profile-btn-primary med-profile-submit-btn">
                                            Update Password
                                        </button>
                                    </form>
                                ) : (
                                    <form onSubmit={verifyOtp} className="med-profile-otp-form">
                                        <div className="med-profile-alert med-profile-alert-info">
                                            A code has been sent to your email. Please enter it below to confirm the password change.
                                        </div>
                                        
                                        <div className="mb-3">
                                            <label htmlFor="otpCode" className="med-profile-label">OTP Code</label>
                                            <input
                                                type="text"
                                                id="otpCode"
                                                placeholder="Enter OTP code"
                                                value={otpCode}
                                                onChange={e => setOtpCode(e.target.value)}
                                                className="med-profile-control"
                                            />
                                        </div>
                                        
                                        <div className="med-profile-otp-actions">
                                            <button type="submit" className="med-profile-btn med-profile-btn-success med-profile-verify-btn">
                                                Verify Code
                                            </button>
                                            <button 
                                                type="button"
                                                className="med-profile-btn med-profile-btn-secondary med-profile-cancel-btn ms-2"
                                                onClick={() => setOtpStage(false)}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
};

export default ProfilePage;